// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import CreatableSelect from 'react-select/creatable';

import Modal from './Modal';

export default class ReportDocument extends Modal {

    state = {
        reason: "",
        notes: ""
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">

            <h1>Report an issue with this document</h1>

            <p>If you see something in the document that is not expected and want to let the Stax·ai team know so they can help you with it, select a reason, enter any notes you have, and hit the submit button below!</p>

            <br />

            <h2>Reason for reporting</h2>
            <div className="form-line form-line-long">
                <CreatableSelect
                    className="multi-select-container"
                    classNamePrefix="multi-select"
                    placeholder="Select or type the reason for reporting..."
                    options={[
                        "Automate error not helpful",
                        "I don't understand the flag",
                        "Document failed even after retry",
                        "Unreliable account match"
                    ].map(o => ({
                        label: o,
                        value: o
                    }))}
                    onChange={(value) => this.setState({ reason: value.value })}
                    value={{
                        label: this.state.reason,
                        value: this.state.reason
                    }}
                />
            </div>

            <div className="form-line form-line-long">
                <label>Notes</label>
                <textarea
                    placeholder="(Optional) Add any notes about this document or specifics on how you got here..."
                    onChange={(e) => this.setState({
                        message: e.target.value
                    })}
                    value={this.state.message}
                    style={{
                        float: 'left',
                        width: "calc(100% - 24px)"
                    }}
                >
                </textarea>
            </div>

            <div style={{
                clear: 'both',
                height: 20
            }} />

            <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/send.png')"
                }}
                onClick={() => this.props.reportDocument(this.props.data, this.state.reason, this.state.notes)}
            >Submit Report</div>
            
        </div>);
    }

};